export class PptUrlData {
  createdDate: Date;
  formatToUrls: any;
}
